import { connect } from 'react-redux';
import * as examSelectors from 'edrolo/domains/exams/data/selectors';
import { QuestionSetPageDemo } from './QuestionSetPageDemo';
import { loadExam } from 'edrolo/domains/exams/data/actions';
import {
  getPrevNextQuestionIds,
  getRootQuestionDescendants,
  filterQuestions,
} from '../../utils';
import { OrderedMap } from 'immutable';
import { getLocalResponses } from './utils';

const mapStateToProps = (
  state,
  { examId, classId, questionId, searchParams }
) => {
  const flatQuestionsUnfiltered = examSelectors.getFlatQuestions(state, examId);
  const flatQuestions = filterQuestions(flatQuestionsUnfiltered, searchParams);

  const prevNextQuestionIds = getPrevNextQuestionIds(flatQuestions, questionId);
  const rootQuestionDescendants = getRootQuestionDescendants(
    flatQuestions,
    questionId
  );

  const question = flatQuestions?.get(questionId);
  const firstChildId = rootQuestionDescendants?.first().get('id');

  let parentQuestions = OrderedMap();

  flatQuestions?.forEach((item) => {
    const children = getRootQuestionDescendants(flatQuestions, item.get('id'));
    const parent = children.first();

    if (!parentQuestions.has(parent.get('id'))) {
      parentQuestions = parentQuestions.set(parent.get('id'), parent);
    }
  });

  const prevNextParentQuestionIds = getPrevNextQuestionIds(
    parentQuestions,
    firstChildId
  );

  const filterToggle = {
    hasSpiciness: !!flatQuestionsUnfiltered?.some((q) =>
      q.get('spiciness_level')
    ),
    hasWorkingPaths: !!flatQuestionsUnfiltered?.some(
      (q) => q.get('working_pathways').size > 0
    ),
  };

  const prevNextIds = {
    prevParentId: prevNextParentQuestionIds.prevId,
    nextParentId: prevNextParentQuestionIds.nextId,
    prevId: prevNextQuestionIds.prevId,
    nextId: prevNextQuestionIds.nextId,
  };

  const questionResponses = getLocalResponses();

  return {
    exam: examSelectors.getExam(state, examId),
    examStatus: examSelectors.getExamLoadingStatus(state, examId),
    sections: examSelectors.getSections(state, examId),
    numQuestions: flatQuestions?.size || 0,
    questionsBySectionId: examSelectors.getFlatQuestionsIndexedBySectionId(
      state,
      examId
    ),
    classId: 1192419,
    getQuestionInstructionText: (questionId) =>
      examSelectors.getSensibleInstructionTextForQuestionId(state, questionId),
    questionResponses,
    question,
    rootQuestionDescendants,
    filterToggle,
    prevNextIds,
    isTeacher: false,
  };
};

const mapDispatchToProps = (dispatch, ownProps) => ({
  loadExam: (examId) => dispatch(loadExam.signal(examId, !!'isDemo')),
  ensureSittingLoaded: (examId) => null,
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(QuestionSetPageDemo);
